import { render, staticRenderFns } from "./ProfilePlaidWrapper.vue?vue&type=template&id=2ec92b76&scoped=true&"
import script from "./ProfilePlaidWrapper.vue?vue&type=script&lang=ts&"
export * from "./ProfilePlaidWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec92b76",
  null
  
)

export default component.exports